module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/press-desktop@2x-b45604de2be3041faca7bd4ed22cc2ef.webp";